export const DEFAULT_TEMPLATE_ACCENT_COLOR = "#d0f435";
/**
 * Normalizes a user-provided template accent color into a six-digit hex color.
 */
export function normalizeTemplateAccentColor(color) {
    if (!color) {
        return null;
    }
    const trimmed = color.trim();
    const match = trimmed.match(/^#?([0-9a-fA-F]{6})$/);
    if (!match) {
        return null;
    }
    return `#${match[1].toLowerCase()}`;
}
/**
 * Reads the LED accent color from a template scene, falling back for legacy templates.
 */
export function getTemplateAccentColor(template) {
    if (!template) {
        return null;
    }
    return (normalizeTemplateAccentColor(template.scene?.style?.accentColor) ??
        DEFAULT_TEMPLATE_ACCENT_COLOR);
}
export function isTemplateSceneV2(scene) {
    return !!scene && Array.isArray(scene.scenes);
}
/**
 * Returns a flat list of layer elements suitable for rendering as a single canvas — for v1 the
 * scene's elements, for v2 the first scene's elements (used by the CMS preview thumbnail). Returns
 * an empty array when the scene shape is not recognized.
 */
export function extractPreviewElements(scene) {
    if (!scene)
        return [];
    if (isTemplateSceneV2(scene)) {
        return scene.scenes[0]?.elements ?? [];
    }
    return scene.elements ?? [];
}
